import { trans } from '@lingoda/i18n';
import { AppBar, Box, Button, IconButton } from '@lingoda/ui';
import { ArrowLeftIcon } from '@lingoda/ui/icons/lingodaIcons';
import { LingodaLogoIcon } from '@lingoda/logotype';
import Toolbar from './Toolbar';

interface Props {
    onBack?: () => void;
    onSkip?: () => void;
}

export const Header = ({ onSkip, onBack }: Props) => (
    <AppBar position="static" color="inherit">
        <Toolbar>
            {onBack ? (
                <IconButton onClick={onBack}>
                    <ArrowLeftIcon size={24} />
                </IconButton>
            ) : (
                <Box ml={2}>
                    <Box sx={{ width: 40 }}>
                        <LingodaLogoIcon />
                    </Box>
                </Box>
            )}

            {onSkip && (
                <Button variant="text" onClick={onSkip} sx={{ mr: 2 }}>
                    {trans('skip', {}, 'student-onboarding')}
                </Button>
            )}
        </Toolbar>
    </AppBar>
);
